module.exports = __webpack_public_path__ + "img/basket_none_ico.309d7a3d.svg";